'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("crmTicketDetails", function ($http, $modal, $translate, $fileDownload, $dialogBox, $authz, lovService, $q, $session, $route, crmTicketService, documentPreview, documentDrop, $notifications) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      ticket: '=',
      refreshFunction: "&",
      edition: "=",
      editionClient: "="
    },
    template: require("./crmTicketDetails.html"),
    controller: function controller($scope) {
      $scope.showDemandeFileDropOverlay = function () {
        return ($scope.edition || $scope.editionClient) && documentDrop.isActive();
      };
      $scope.showReponseFileDropOverlay = function () {
        return $scope.edition && documentDrop.isActive();
      };
      $scope.intra = $authz.isIntra();
      $scope.supprimerTicket = function (ticket) {
        $dialogBox.confirm({
          title: $translate("common.confirm_delete"),
          text: 'Confirmez vous la suppression du ticket ' + ticket.titre || '' + " ?"
        }).then(function () {
          $http.delete("/rest/echange/ticket/delete/" + ticket.id).then(function (response) {
            $scope.refreshFunction();
          });
        });
      };
      $scope.editTicket = function (ticket) {
        openEditionPopin(ticket).then(function () {
          $scope.refreshFunction();
        });
      };

      // edition popin

      var openEditionPopin = function openEditionPopin(ticket) {
        return crmTicketService.openEditionPopin($scope, ticket);
      };
      $scope.demandeUploadOptions = {
        url: '/rest/echange/document',
        formData: {
          ticketId: $scope.ticket.id
        },
        dropZone: '.block_demande'
      };
      $scope.reponseUploadOptions = {
        url: '/rest/echange/document',
        formData: {
          ticketId: $scope.ticket.id
        },
        dropZone: '.block_reponse'
      };
      $scope.$watch('ticket.id', function () {
        $scope.demandeUploadOptions.formData.ticketId = $scope.ticket.id;
        $scope.reponseUploadOptions.formData.ticketId = $scope.ticket.id;
        $http.get('/rest/echange/comptes-cible-deplacement-ticket/' + $scope.ticket.id).then(function (response) {
          $scope.comptesAccessibles = response.data;
        });
      });
      $scope.downloadDocument = function (document) {
        $fileDownload.start('/rest/echange/download/' + document.id);
      };
      $scope.downloadAllDemandeDocuments = function () {
        $fileDownload.start('/rest/echange/download-all-documents-reponse/' + $scope.ticket.id);
      };
      $scope.removeDocument = function (document) {
        $dialogBox.confirm({
          title: $translate("common.confirm_delete"),
          text: $translate("saisie.documents.popins.delete.text", {
            filename: document.name
          })
        }).then(function () {
          $http.delete("/rest/echange/remove-document", {
            params: {
              docId: document.id
            }
          }).then(function () {
            $scope.refreshFunction();
          });
        });
      };
      $scope.onResultatUpload = function () {
        $scope.refreshFunction();
      };
      $scope.editDocument = function (document) {
        crmTicketService.openDocumentEditionPopin($scope, document).then(function (updatedDocument) {
          $http.get("/rest/echange/update-document-name", {
            params: {
              docId: document.id,
              name: updatedDocument.name
            }
          }).then(function () {
            $scope.refreshFunction();
          });
        });
      };
      $scope.canPreviewDoc = function (document) {
        return documentPreview.canPreview(document);
      };
      $scope.previewDocument = function (document) {
        documentPreview.openPopin(document);
      };

      // edition client popin

      $scope.editTicketClient = function (ticket) {
        openEditionClientPopin(ticket).then(function () {
          $scope.refreshFunction();
        });
      };
      var openEditionClientPopin = function openEditionClientPopin(ticket) {
        return crmTicketService.openEditionClientPopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.deplacerTicket = function (ticket) {
        crmTicketService.openDeplacerPopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.copyToClipboard = function () {
        navigator.clipboard.writeText("https://tael.taelys.com/tael/echanges/nos-echanges?viewId=" + $scope.ticket.id + "&toCompte=" + $scope.ticket.compteId).then(function () {
          $notifications.info('Lien copié le presse papier');
        }).catch(function (e) {
          return console.error(e);
        });
      };
      $scope.openMessagePopin = function ($scope, ticket) {
        return $modal.open({
          scope: $scope,
          controller: "ticketAddMessagePopinController",
          template: require("./addMessage/ticketAddMessagePopin.html"),
          vars: {
            ticket: ticket
          },
          options: {
            width: 960
          }
        });
      };
      $scope.addMessage = function () {
        $scope.openMessagePopin($scope, $scope.ticket).then(function () {
          $scope.refreshFunction();
        });
      };
      $scope.demandeReouverture = function (ticket) {
        crmTicketService.openDemandeReouverturePopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.annulerDemandeReouverture = function (ticket) {
        crmTicketService.openAnnulerDemandeReouverturePopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/fiche/crmTicketDetails.js
// module id = 2894
// module chunks = 13